import React from 'react';
import { FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import SubTask from '@/components/SubTask';
import { TaskStatus } from '@/types/productFeed';
import DownloadReportField from '@/components/DownloadReportField';
import { subTaskNameConstants } from '@/lib/constants/subTaskNameConstants';

interface Step1CompletionProps {
  vendor: string;
  fileName: string;
  fileSize: string;
  onProcessImages: () => void;
  stepOneTasks: TaskStatus;
}

const Step1Completion: React.FC<Step1CompletionProps> = ({
  vendor,
  fileName,
  fileSize,
  onProcessImages,
  stepOneTasks
}) => {
  const subTasks = stepOneTasks?.subTasks || [];
  const rawFeedReportGeneratedTask = subTasks.find(task => task.task === subTaskNameConstants.rawFeedReportGenerate);
  return (
    <div className="space-y-6">
      {/* SubTask Component */}
      <SubTask subTasks={subTasks} />
      {/* Status Section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Upload & Validation */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Upload & Validation</h3>
            </div>
            
            {/* Download Report Field */}
            <DownloadReportField
              status={rawFeedReportGeneratedTask?.status?.toLowerCase() || 'pending'}
              rawProductFeedValidationReportLocation={rawFeedReportGeneratedTask?.rawProductFeedValidationReportLocation}
            />

            {/* Process Images Button */}
            <button 
              // disabled={!subTasks?.length || !subTasks.every(task => task?.status === "completed") || stepOneTasks?.status !== "completed"}
              disabled={!subTasks?.length || !subTasks.every(task => task?.status === "completed")}
              onClick={onProcessImages}
              className="w-full bg-teal-600 hover:bg-teal-700 text-white p-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Process images with valid records
            </button>
          </div>

          <Separator />

          {/* File Information */}
          <div className="space-y-3">
            <h3 className="text-sm font-medium">File Information</h3>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Vendor:</span>
                <span className="text-sm font-medium">{vendor}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">File:</span>
                <div className="flex items-center space-x-1">
                  <FileText className="h-3 w-3 text-gray-400" />
                  <span className="text-sm font-medium max-w-xs truncate">{fileName}</span>
                </div>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Size:</span>
                <span className="text-sm font-medium">{fileSize}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Status:</span>
                <Badge className="bg-blue-100 text-blue-700">{stepOneTasks?.status || 'Pending'}</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Step1Completion; 